export const FOOTER_LINKS = [
  {
    "keyPolicies": [
      {
        "displayName": "Risk Factors",
        "url": "risk-factor"
      },
      {
        "displayName": "Disclaimer",
        "url": "disclaimer"
      },
      {
        "displayName": "Privacy Policy",
        "url": "privacy-policy"
      },
      {
        "displayName": "Cookie Policy",
        "url": "cookie-policy"
      },
      {
        "displayName": "Terms of Use",
        "url": "terms-of-use"
      }
    ],
    "quickLinks": [
      {
        "displayName": "Statutory Disclosure",
        "url": "statuory-disclosure",
      },
      {
        "displayName": "Downloads",
        "url": "downloads"
      },
      {
        "displayName": "NAV & IDCW",
        "url": "nav-dividends"
      },
      {
        "displayName": "FAQs",
        "url": "faq"
      }
    ],
    "otherLinks": [
      {
        "displayName": "SEBI",
        "url": "https://www.sebi.gov.in/"
      },
      {
        "displayName": "AMFI",
        "url": "https://www.amfiindia.com/"
      },
      {
        "displayName": "RBI",
        "url": "https://www.rbi.org.in/"
      },
      {
        "displayName": "Local Branch Locater",
        "url": "https://itimfbranches.itiamc.com/"
      }
    ],
    "HelpLinks": [
      {
        "displayName": "Careers",
        "url": "careers"
      },
      {
        "displayName": "Request call back",
        "url": "call-back"
      },
      {
        "displayName": "Write to us",
        "url": "write-to-us"
      },
      {
        "displayName": "Locate us",
        "url": "locate-us"
      },
      {
        "displayName": "KFintech Branches",
        "url": "karvy-branches"
      },
      {
        "displayName": "ITI AMC Branches ",
        "url": "amc-branches"
      },
      {
        "displayName": "Locate your Advisor",
        "url": "locate-advisor"
      }
    ]
  }
]
